import { smpReducer } from "./bplrt/smpReducer";
import { equipmentReducer } from "./bplrt/equipmentReducer";
import { disruptionReducer } from "./smrt/disruptionReducer";
import { srgLinesReducer } from "./smrt/srgLinesReducer";

const externalFeatureReducers = {
  smrtDisruption: disruptionReducer,
  bplrtSmp: smpReducer,
  bplrtEquip: equipmentReducer,
  srgLines: srgLinesReducer,
};

export default externalFeatureReducers;
